import { PaymentInfo } from "./types/PartialProduct";

export type IntentResult = {
  needs_confirmation: boolean;
  redirect_url: string;
  error?: object;
  id: string;
  email?: string;
  order_id?: string;
  order_key?: string;
};

export async function PayStripe(
  info: PaymentInfo,
  productId: string,
  promoCode?: string
): Promise<IntentResult | undefined> {
  const promoPiece = promoCode ? `?promo=${promoCode}` : "";
  const resp = await fetch(`/api/pay/${productId}${promoPiece}`, {
    method: "POST",
    body: JSON.stringify(info),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (resp.status >= 400) return undefined;

  return (await resp.json()) as IntentResult;
}
